module.exports = __webpack_public_path__ + "static/fonts/nucleo-icons.861720f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nucleo-icons.woff
// module id = DQA7
// module chunks = 4